import { render, staticRenderFns } from "./ActivityConfigCopyModal.vue?vue&type=template&id=6fa13d6e&scoped=true"
import script from "./ActivityConfigCopyModal.vue?vue&type=script&lang=js"
export * from "./ActivityConfigCopyModal.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfigCopyModal.vue?vue&type=style&index=0&id=6fa13d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa13d6e",
  null
  
)

export default component.exports